module.exports = __webpack_public_path__ + "static/img/post2.6af3586.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post2.jpg
// module id = AlH4
// module chunks = 192